import(/* webpackMode: "eager" */ "/src/src/components/loading-screen/loading-screen.tsx");
;
import(/* webpackMode: "eager" */ "/src/src/components/loading-screen/splash-screen.tsx");
